export const filterFormPropsDefaults = {
  columnInputProps: {
    variant: 'outlined',
    size: 'small',
  },
  operatorInputProps: {
    variant: 'outlined',
    size: 'small',
  },
  logicOperatorInputProps: {
    variant: 'outlined',
    size: 'small',
  },
  valueInputProps: {
    // The value input is a special case, because it can contain a wide variety of components
    // Pass props directly to the InputComponent and not its wrapper
    InputComponentProps: {
      variant: 'outlined',
      size: 'small',
    },
  },
};
